import { render, staticRenderFns } from "./UserActivityView.vue?vue&type=template&id=34f8b7d8&scoped=true&"
import script from "./UserActivityView.vue?vue&type=script&lang=ts&"
export * from "./UserActivityView.vue?vue&type=script&lang=ts&"
import style0 from "./UserActivityView.vue?vue&type=style&index=0&id=34f8b7d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f8b7d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
